export const MESSAGING_KEY = 'messaging';
